jQuery(document).ready(function($) {

  'use strict';

   var c, currentScrollTop = 0,
       navbar = $('.header');

   $(window).scroll(function () {
      var a = $(window).scrollTop();
      var b = navbar.height();

      currentScrollTop = a;

      if (c < currentScrollTop && a > b + b) {
        navbar.addClass("header-scroll-up");
        $('.top-bar--floating-links').addClass("floating-links-scroll-down");
      } else if (c > currentScrollTop && !(a <= b)) {
        navbar.removeClass("header-scroll-up");
        $('.top-bar--floating-links').removeClass("floating-links-scroll-down");
      }
      c = currentScrollTop;
  });
  $(".online-services-btn").click(function (e) {
    e.preventDefault();
   $('.online-services-links').toggleClass('show-bar');
   $(this).toggleClass('online-services-btn__active');
   $('.search-block').removeClass('show-bar');
   $('.top-bar--floating-links--btn__search').removeClass('top-bar--floating-links--btn__search__active');
  });

  $(".top-bar--floating-links--btn__search").click(function (e) {
    e.preventDefault();
   $('.search-block').toggleClass('show-bar');
   $(this).toggleClass('top-bar--floating-links--btn__search__active');
   $('.online-services-links').removeClass('show-bar');
   $('.online-services-btn').removeClass('online-services-btn__active');
   if($('.search-block').hasClass('show-bar')){
      $('.search-unit .search-field').focus();
   }
  });
  $(".search-menu li a").click(function (e) {
    e.preventDefault();
    $(".search-menu li a").removeClass("active");
    $(".search-type").removeClass("active");
    var target = $(this).attr("data-target");
    $(this).addClass("active");
    $(target).toggleClass("active");
    $(target).find("input.search-field").focus();
  });
  /*$("#open-c-form").click(function (e) {
    e.preventDefault();
    $('.c-contact-details-block').slideToggle('300');
    $('html, body').animate({
      scrollTop: $(".c-contact-details-block").offset().top
    });
  });*/
// Parameters behind url --- This was used for showing popup windows based on url
/*
  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
  var dynamicContent = getParameterByName('welcome');

  if (dynamicContent == 'show') {
    $('.notification-overlay').show();
    $('#welcome-text').show();
  }
  if (dynamicContent == 'show-jyvaskyla') {
    $('.notification-overlay').show();
    $('#jyvaskyla-text').show();
  }
  if (dynamicContent == 'show-msg-two') {
    $('.notification-overlay').show();
    $('#msg-two').show();
  }
  if (dynamicContent == 'show-piha-talohuolto') {
    $('.notification-overlay').show();
    $('#piha-talohuolto-text').show();
  }

  $(".close-overlay").click(function (e) {
    e.preventDefault();
   $('.notification-overlay').hide();
  });
*/ 

  // tarjouslomake open
  var captcha = false;
  $('.open-c-form').one('click', function(e) {
    e.preventDefault();
    if ( captcha ) return;
    captcha = true
    var head = document.getElementsByTagName('head')[0]
    var script = document.createElement('script')
    script.type = 'text/javascript';
    script.src = 'https://www.google.com/recaptcha/api.js?hl=fi'
    head.appendChild(script);
  });

  // tarjouslomake datalayer
  $('form.lead-form').on('submit', function(e) {

    $( ".recaptcha-message" ).text(" ");
    $( ".lomake-kiitos .sending" ).show();
    $( ".lomake-kiitos .lead-form").hide();

    $.post( "/", $( this ).serialize()).done(function( data ) {

      $( ".lomake-kiitos .sending" ).hide();

      if (data == 1) {
        window.dataLayer.push({
            "event" : "bannerilomake_submission",
            "formId" : "lead-form",
            "tunniste" : $("#tunniste", this).val(),
            "response" : $( this ).serialize()
        });
        $( ".lomake-kiitos .thankyou" ).show();
      }

      if (data == 2) {
        $( ".recaptcha-message" ).text("Täytä reCAPTHA kenttä.");
        $( ".lomake-kiitos .lead-form").show();
      }

      if (data == 3) {
        $( ".recaptcha-message" ).text("Jokin meni vikaan.");
        $( ".lomake-kiitos .lead-form").show();
      }
      
    });

    return false;
  });
 
  // muut lomakkeet datalayer
  $('.khForm:not(.wordpress-ajax-form)').on('submit', function(e) {
      window.dataLayer.push({
          'event': 'formSubmit',
          'formname': ajax_object.formi,
      });

    return true;
  });

  // karuselli
  if ( $( ".slider" ).length ) {
    $(".slider").slick({
        dots: true,
        //arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false
    });
  }

  // karuselli tag manager
  $(".slider").on('afterChange', function(event, slick, currentSlide) {
    if (currentSlide == 1) {
      window.dataLayer.push({
        "event" : "karuselli_first_click",
      });
    }
    if (slick.$slides.length-1 == currentSlide) {
      window.dataLayer.push({
        "event" : "karuselli_last_click",
      });
    }
  });
  
  $(document).on('facetwp-loaded', function() {
    var params = decodeURIComponent(window.location.search);
    var urlParams = new URLSearchParams(params);
    if (FWP.loaded && urlParams.has('_kategoriat')) {
        //console.log(urlParams.get('_kategoriat'));
        window.dataLayer.push({
          "event" : "ajankohtaista_fwp",
          "fwp_params" : urlParams.get('_kategoriat')
        });
    }
  });

  // yksikön päivystys
  if ( $(".active_numbers_info_normal").length ) {

    var today = new Date();
    var time = today.getHours();
    var weekend = (today.getDay() == 6 || today.getDay() == 0) ? true : false;

    if ( weekend ) {
      $(".hotline_hours_msg").hide();
    }

    if ( time >= unit_phone_opening_hours_start && time < unit_phone_opening_hours_end && weekend === false ) {
      $(".active_numbers_info_normal").addClass( "active" );
    } else {
      $(".active_numbers_info_paivystys").addClass( "active" );
    }

  }

});